export default __webpack_public_path__ + "static/media/nonotofication.06e972d1.jpg";